import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useLayoutEffect,
  useCallback,
} from "react";
import { useNavigate } from "react-router-dom";
import "./FinalPage.css";
import "../Dashboard/Dashboard.css";
import "../ResultAll/ResultAll.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { faListDropdown } from "@fortawesome/free-solid-svg-icons";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import { useParams } from "react-router-dom";
import "../AsmDetail/AsmDetail.css";
import Dashboard from "../Dashboard/Dashboard";
import bear from "../../images/f1.jpg";
import loadimg from "../../images/pp-logo.gif"; 
import { END_URL, IMG_URL } from "../../config";
import axios from "axios";
import ResultChart from "../ResultChart/ResultChart";
import Subscriptions from "../Subscriptions/Subscriptions";
import ResultPageLast from "../ResultPageLast/ResultPageLast";
import SideResult from "../SideArche/SideResult";
import ResultSlider from "../ResultSlider/ResultSlider";
import asm from "../../images/ann.png";
import { Helmet } from 'react-helmet';

import { faXmark } from '@fortawesome/free-solid-svg-icons';
import CalculateArchetype from "../CalculateArchetype/CalculateArchetype";
import { useLocation } from "react-router-dom";
import Trail from "../Trail/Trail";
import ResultTwo from "../ResultTwo/ResultTwo";
import GradientSlider from "../GradientSlider/GradientSlider";
import { Doughnut } from "react-chartjs-2";
import DoughnutLinearChart from "../DoughnutLinearChart/DoughnutLinearChart";
import ky from "../../images/key11.svg";
import sy from "../../images/weight.svg"
import sy1 from "../../images/stariconnew.svg"


function FinalPage({ onLoginChange, globaltest,userdetail ,admin}) {

  const [IsAdmin, setIsAdmin] = useState(admin);

  const location = useLocation();

  const isCalculatingMode = location.search.includes("calculating");

  const { slug, test_slug } = useParams();
  const [dimension, setDimension] = useState(null);
  const [badge, setBadge] = useState(null);
  const [cluster, setCluster] = useState(null);
  const [test, setTest] = useState(null);
  const [existingResult, setExistingResult] = useState(null);
  const [resultDetails, setResultDetails] = useState([]);
  const [HavePastTest, setHavePastTest] = useState(false);

  const [resultReady, setResultReady] = useState(false);
  const subS = false;
  const contentRefs = useRef([]);

  const observerRef = useRef(null);
  const isManualScrollRef = useRef(false);

  const [timeoutPassed, setTimeoutPassed] = useState(false);

  const [calculationLoaded, setCalculationLoaded] = useState(true);
    
  const token = localStorage.getItem("token");

    useEffect(() => { 
      
            FetchCalculation();
  
    }, []);
  
    const FetchCalculation = async () => {
      try {
        const response = await fetch(`${END_URL}/calculation/${slug}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
  
        const data = await response.json();
        
        setTestInfo(data?.data);
  
      } catch (error) {
  
      } finally {
        setCalculationLoaded(true);
      }
    };

  const handleFocus = useCallback((index) => {
    isManualScrollRef.current = true;

    const targetElement = contentRefs.current[index];
    if (targetElement) {
      try {
        const elementTop =
          targetElement.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementTop - 120;

        window.scrollTo({
          top: Math.max(0, offsetPosition),
          behavior: "smooth",
        });
      } catch (error) {
        console.warn("Scroll with offset failed, using fallback:", error);

        try {
          const elementTop =
            targetElement.getBoundingClientRect().top +
            (window.pageYOffset || document.documentElement.scrollTop);
          const offsetPosition = elementTop - 120;

          if (window.scrollTo) {
            window.scrollTo({
              top: Math.max(0, offsetPosition),
              behavior: "smooth",
            });
          } else {
            document.documentElement.scrollTop = Math.max(0, offsetPosition);
          }
        } catch (fallbackError) {
          console.error("All scroll methods failed:", fallbackError);
        }
      }
    }

    setTimeout(() => {
      isManualScrollRef.current = false;
    }, 1500);
  }, []);

  const [TestInfo, setTestInfo] = useState(() => {

      const saved =
        localStorage.getItem(
          `calculation_${slug}`
        );

      return saved
        ? JSON.parse(saved)
        : [];
  });


  const TestDone = useRef(null);

  useEffect(() => {
    FetchResultDatas();
  }, [slug, test_slug]);

  useEffect(() => {
    if (Array.isArray(resultDetails) && resultDetails.length > 0) {
      setResultReady(true);
    }
  }, [resultDetails]);

  const FetchResultDatas = async () => {
    try {
      const response = await fetch(
        `${END_URL}/result-clusterfinal/${slug}/${test_slug}`,
        {
          method: "POST",
            headers: { 
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
           },
           body: JSON.stringify({
            admin: IsAdmin ? true : false,
          }), 
          
        }
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      setDimension(data.dimension);
      setCluster(data.cluster);
      setBadge(data.badge);
      setTest(data.test);
      setExistingResult(data.existing_result);
      setResultDetails(data.result_details);
    } catch (error) {
      console.error("Error sending result:", error);
    } finally {
      // setIsLoading(false);
    }
  };

  const [tests, setTests] = useState([]);

  const LocalTest = JSON.parse(localStorage.getItem(slug));

  const [testData, settestData] = useState([]);

  const [Result, setResult] = useState("");

  const [Demension, setDemension] = useState([]);

  const [getBladge, setgetBladge] = useState([]);

  const [hasSubscription, setHasSubscription] = useState(false);
  const [hasplan, setHasPlan] = useState({});

  const user = localStorage.getItem("user");
  const navigate = useNavigate();

  const TestSaved = localStorage.getItem(`test_${LocalTest?.test?.id}`);

  const [Opacity, setOpacity] = useState(true);

  const [SubPlan, setSubPlan] = useState({});

  const [Subcription, setSubcription] = useState([]);

  const [TestSubcription, setTestSubcription] = useState([]);

  const [TestResut, setTestResut] = useState([]);

  const [SavedTest, setSavedTest] = useState(false);

  const [isLoading, setIsLoading] = useState(true);

  const [ResultLast, setResultLast] = useState(true);

  const subAd = true;

  const [subscription, setSubscription] = useState(null);

  const [ShowModal, setShowModal] = useState(false);

  const [TestLink,setTestLink] = useState(null);

  const [TestLink1,setTestLink1] = useState(null);

  const [RareDate,setRareDate] = useState([]); 

  const result_letter = useMemo(() => {
    return (
      testData?.data?.map((item) => ({
        final_letter:
          item.letter === "left" ? item.leftletter : item.rightletter,
      })) || []
    );

    if (!testData) {
      testData = {
        test_slug: test_slug,
        slug: slug,
      };
    }
  }, [testData]);

  useEffect(() => {
    // setIsLoading(true);

    if (!SavedTest) {
      settestData(LocalTest);
      // setIsLoading(false);
    }

    if (SavedTest) {
      FetchUserResult();
    }
  }, [SavedTest]);

  const FetchUserResult = async () => {
    try {
      const response = await fetch(`${END_URL}/user-result`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      const result = data?.data?.result;

      const test = {
        test: {
          id: data.test.id,
          name: data.test.name,
          type: data.test.type,
          slug: data?.test?.slug || "",
          test_slug: data?.data?.test_slug || "",
          result_test_name:  data.test.result_test_name || "",
          rarity_percentage:data?.data?.rarity_percentage || "",
        },
      };

      const resultdata = {
        data: data?.data?.categoryresult?.map((item, index) => ({
          category_id: item.id,
          left_result: item.left_result,
          leftlabel: item.resultcategory.left_label,
          leftletter: item.resultcategory.leftletter,
          letter: item.letter,
          name: item.name,
          right_result: item.right_result,
          rightlabel: item.resultcategory.right_label,
          rightletter: item.resultcategory.rightletter,
        })),
      };

      const ConvertedtestData = {
        ...resultdata,
        result: result,
        ...test,
      };

      settestData(ConvertedtestData);

    } catch (error) {
      console.error("Error sending result:", error);
    }
  };

  useEffect(() => {
    const SubcriptionDetail = async () => {
      try {
        const response = await axios.get(`${END_URL}/get-subcription`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const reponsedata = response.data;

        setSubcription(reponsedata);
      } catch {
        console.log("some error ");
      }
    };

    SubcriptionDetail();
  }, []);

  useEffect(() => {
    if (user) {
      SaveTest();
    } 
    else if(IsAdmin)
    {
      console.log('admin');
    }
    else {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        onLoginChange(true);
      }, 5000);
    }

  }, [user, token,IsAdmin]);

  useEffect(() => {
    const checkSlugSubscription = async () => {
      try {
        const response = await axios.get(
          `${END_URL}/subscription/check/${slug}/${test_slug}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setHasSubscription(response.data.has_subscription);

        setHasPlan(response.data.plan);
      } catch (error) {
        setHasSubscription(false);
      }
    };

    checkSlugSubscription();
  }, [user, token]);

  useEffect(() => {
    if (Array.isArray(result_letter) && result_letter.length > 0) {
      const finalResult = result_letter
        .map((item) => item.final_letter)
        .join("");

      setResult(finalResult);
    }
  }, [result_letter]);

  useEffect(() => {
    axios
      .get(`${END_URL}/tests`)
      .then((response) => {
        setTests(response.data);
      })
      .catch((error) => {
        console.error("Error fetching tests:", error);
      });
  }, []);

  const SaveTest = async () => {
    try {
      const response = await axios.post(
        `${END_URL}/submit/test/${slug}/${test_slug}`,
        LocalTest,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      const testsave = response.data.saved;

      setResult(response.data.result);

      setSavedTest(testsave);
    } catch (error) {
      console.error("Error sending result:", error);
    }
  };

  useEffect(() => {
    if (Result || IsAdmin) {
      FetchResultData(Result);
    }
  }, [Result, IsAdmin]);

  const FetchResultData = async (finalResult) => {
    try {
      const response = await fetch(
        `${END_URL}/result-cluster-final/${slug}/${test_slug}`,
        {
          method: "POST",
          headers: {
             Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },

          body: JSON.stringify({ result: finalResult,admin: IsAdmin ? true : false, }),
        }
      );

      const data = await response.json();

      setDemension(data.dimensions);

      setCluster(data.cluster);

      setgetBladge(data.bladge);
      setHavePastTest(data.have_past_test);

      setTestLink(data?.advertisment_image_link?.slug);

      setTestLink1(data?.paid_test_sub_button_link?.slug);

      setRareDate(data.extest?.rarer_percentage);

      settestData({
        test: data.test,
        data: data.data,
        rarity_percentage:data.extest?.rarity_percentage,
      });

      setIsLoading(false);

    } catch (error) {
      console.error("Error sending result:", error);
    }
  };

  const testsubscription = testData?.test?.type;

  const typetest =
    testsubscription === "free_test" ? "type_1" : testsubscription;

  const subplan = Subcription?.data?.filter((item) => {
    return item.type === typetest;
  });

  useEffect(() => {
    window.history.pushState(null, document.title, window.location.href);
    const handlePopState = (event) => {
      window.history.pushState(null, document.title, window.location.href);
    };
    window.addEventListener("popstate", handlePopState);
    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  const [isTop, setIsTop] = useState(false);

  const [scollClass, setscollClass] = useState("");

  // const [isBottom, setIsBottom] = useState(false);

  const sideResultRef = useRef(null);

    const handleNavigete = (link) => {

        if (link) {
        window.location.href = `/${link}`;
        }
    };


  const handleSub = async (subJson) => {

      try {

          setShowModal(true);

          let subIds = subJson;

          if (typeof subJson === "string") {
          try {
              subIds = JSON.parse(subJson);
          } catch (e) {
              console.error("Invalid JSON string for subIds:", e);
              return;
          }
          }

          if (!Array.isArray(subIds) || subIds.length === 0) {
          console.warn("No valid subscription IDs found:", subIds);
          return;
          }

          const res = await axios.post(
          `${END_URL}/sub_adver`,
          { ids: subIds },
          {
              headers: {
              Authorization: `Bearer ${token}`,
              },
          }
          );

          setSubscription(res.data);

      } catch (err) {

          console.error("Error loading subscriptions:", err);
      }
  };


  useEffect(() => {
    // Cleanup existing observer
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }

    if (!resultDetails?.length) return;

    // Clear existing refs array
    contentRefs.current = [];

    // Wait for DOM to be ready
    const setupObserver = () => {
      try {
        // Find all content elements that have titles (only those shown in sidebar)
        const elementsToObserve = document.querySelectorAll(
          ".final-part1[data-index]"
        );

        if (!elementsToObserve.length) {
          console.warn("No .final-part1[data-index] elements found");
          return;
        }

        // Create intersection observer with production-safe options
        const observer = new IntersectionObserver(
          (entries) => {
            if (isManualScrollRef.current) return; // Skip during manual scrolling

            let visibleEntry = null;
            let maxRatio = 0;

            // Find the most visible entry
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio > maxRatio) {
                maxRatio = entry.intersectionRatio;
                visibleEntry = entry;
              }
            });

            // Update active index for most visible element
            if (visibleEntry) {
              try {
                const index = parseInt(visibleEntry.target.dataset.index, 10);
                if (!isNaN(index) && index >= 0) {
                  // Use setTimeout to ensure smooth updates
                  setTimeout(() => {
                    if (
                      sideResultRef.current?.setActiveIndex &&
                      !isManualScrollRef.current
                    ) {
                      sideResultRef.current.setActiveIndex(index);
                    }
                  }, 50);
                }
              } catch (error) {
                console.warn("Error processing intersection entry:", error);
              }
            }
          },
          {
            root: null,
            rootMargin: "-20% 0px -60% 0px",
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1.0], // Multiple thresholds for better detection
          }
        );

        // Observe all content elements
        elementsToObserve.forEach((el) => {
          if (el && el.nodeType === Node.ELEMENT_NODE) {
            observer.observe(el);
          }
        });

        observerRef.current = observer;

        console.log(
          `Observing ${elementsToObserve.length} elements with titles`
        );
      } catch (error) {
        console.error("Error setting up intersection observer:", error);
      }
    };

    // Setup observer after a small delay to ensure DOM is ready
    const timeoutId = setTimeout(setupObserver, 200);

    return () => {
      clearTimeout(timeoutId);
      if (observerRef.current) {
        observerRef.current.disconnect();
        observerRef.current = null;
      }
    };
  }, [resultDetails]);

  useEffect(() => {
    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    if (isTop) {
      setscollClass("side_result_active");
    } else {
      setscollClass("");
    }
  }, [isTop]);

  const handleSliderImageLoaded = () => {
    // setResultReady(true);
  };

  // small screen side bar script.........

  const [isOpen, setIsOpen] = useState(false);
  const sidebarRef = useRef(null);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  // Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        !event.target.closest(".menu-toggleBar")
      ) { 
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);


  const [tierData, setTierData] = useState([]);

    useEffect(() => {

      const fetchTiers = async () => {

        try {

          const res = await fetch(`${END_URL}/trait-tiers`);

          const data = await res.json();

          setTierData(data);
        } catch (err) {

          console.error("Failed to load tier data", err);
        }
      };

      fetchTiers();
    }, []);

  useEffect(() => {
      const timer = setTimeout(() => {
        setTimeoutPassed(true);
      }, 8000);

      return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (timeoutPassed) {
      navigate(location.pathname, { replace: true });
    }
  }, [timeoutPassed]);

  const dataReady = (!isLoading || IsAdmin ) && resultReady;

  const showLoader = !(timeoutPassed && dataReady);

  const showCalculatingLoader = isCalculatingMode && (!calculationLoaded || !(timeoutPassed && dataReady));

  const showNormalLoader = !isCalculatingMode && !dataReady;

    useEffect(() => {

      window.scrollTo({ top: 0, behavior: "smooth" });
      
    }, []);

    if (showCalculatingLoader) {
      return (
        <CalculateArchetype token={token} slug={slug} test_slug={test_slug} TestInfo={TestInfo} />
      );
    }

    if (showNormalLoader) {
      return (
        <div className="loader-container">
          <img src={loadimg} alt="Loading..." className="loader-gif" />
        </div>
      );
    }

  return (
    
    <>
     <Helmet>
                  
            <meta property="og:image" content={`${IMG_URL}/d0/${Demension?.share_image}`} />

            <meta name="twitter:image" content={`${IMG_URL}/d0/${Demension?.share_image}`} />
              
    </Helmet>

    <div className="final-main result-cont">

      <ResultSlider
        dimension={Demension}
        onImageLoadComplete={handleSliderImageLoaded}
      />

      <div className="container-fluid for-sidebar">
        <div className="row result-cont-row">
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 das-res">

            {!IsAdmin && (

                <Dashboard globaltest={globaltest} />

            )}

            {Demension?.advertisment_image && (

              <div className="adver-title">
                  <a

                    // href={`/${Demension?.advertisment_image_link}`}

                    onClick={
                                TestLink != "" && TestLink != null
                                    ? () => handleNavigete(TestLink)
                                    : () => handleSub(Demension?.advertisment_image_link)
                            }

                    className="adver-link"
                  >
                    <div className="dark-adverts final-advet">
                      <img
                        loading="lazy"
                        src={`${IMG_URL}/d0/${Demension?.advertisment_image}`}
                        alt=""
                      />
                    </div>
                  </a>
              </div>
            )}

            {Demension?.advertisment_title &&(

              <h5>{Demension?.advertisment_title}</h5>

            )}
            
            {resultDetails &&
              resultDetails.length > 0 &&
              resultDetails.filter((item) => item.title).length > 0 && (
                <SideResult
                  sideclass={scollClass}
                  ref={sideResultRef}
                  onMenuItemClick={handleFocus}
                  resultDetails={resultDetails
                    .filter((item) => item.title)
                    .map((item, idx) => ({
                      ...item,
                      _index: idx,
                      _originalIndex: resultDetails.findIndex(
                        (original) => original === item
                      ), // Keep track of original index
                    }))}
                />
              )}
          </div>

          <div className="col-12 col-sm-12 col-md-9 col-lg-9 final-col">
            <>
              <span className="menu-toggleBar" onClick={handleToggle}>
                  <FontAwesomeIcon  className={`crs ${isOpen ? 'show' : 'hide'}`} icon={faXmark} />
                              <FontAwesomeIcon     className={`mnus ${isOpen ? 'hide' : 'show'}`} icon={faBars} />
              </span>

              <div
                className={`common-sidebar ${isOpen ? "open" : ""}`}
                ref={sidebarRef}
              >
                <div className={`lsit-item-component ${isOpen ? "open" : ""}`}>
                  {resultDetails &&
                    resultDetails.length > 0 &&
                    resultDetails.filter((item) => item.title).length > 0 && (
                      <SideResult
                        sideclass={scollClass}
                        ref={sidebarRef}
                        onMenuItemClick={(...args) => {
                          handleFocus(...args); // your existing logic
                          setIsOpen(false); // close sidebar
                        }}
                        resultDetails={resultDetails
                          .filter((item) => item.title)
                          .map((item, idx) => ({
                            ...item,
                            _index: idx,
                            _originalIndex: resultDetails.findIndex(
                              (original) => original === item
                            ),
                          }))}
                      />
                    )}
                </div>
              </div>
            </>

            <div className="final-col-inner">
              {(() => {
                const groupedElements = [];
                let buffer = [];
                let contentRefIndex = 0;

                const isExtendSection = (classStr) =>
                  classStr.split(" ").includes("extend_section");

                resultDetails.forEach((item, index) => {
                  const contentTypeClass = item.content_type
                    ? item.content_type
                    : "";

                  const contentDiv = (
                    <div
                      className={`final-part1 ${contentTypeClass}`}
                      ref={(el) => {
                        if (item.title && el) {
                          contentRefs.current[contentRefIndex] = el;
                          el.setAttribute(
                            "data-index",
                            contentRefIndex.toString()
                          ); // Use setAttribute for better compatibility
                          contentRefIndex++;
                        }
                      }}
                      key={item.id || index}
                      dangerouslySetInnerHTML={{ __html: item.content }}
                    />
                  );

                  if (isExtendSection(contentTypeClass)) {
                    buffer.push(contentDiv);
                  } else {
                    if (buffer.length > 0) {
                      groupedElements.push(
                        <div className="extend-common" key={`group-${index}`}>
                          {buffer}
                        </div>
                      );
                      buffer = [];
                    }

                    groupedElements.push(contentDiv);

                     if (index === 0 && Demension?.rarity_common) {

                            groupedElements.push(
                                <>

                                  <div className="result-newDash2" key="rarity-common-section">

                                      <div className="result-newDash2-title">
                                        <span>

                                          <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />
                                          
                                        </span>
                                        <div>
                                          <h5> {Demension?.rarity_common?.rarity_section_title}</h5>
                                          <p>
                                              {Demension?.rarity_common?.rarity_section_description}
                                          </p>
                                        </div>
                                      </div>

                                      <div className="result-newDash2-box" style={{"--color-border": Demension?.rarity_common?.rarity_post_color}} >

                                          <div className="result-newDash2-b1">
                                            <div>
                                              <span style={{"--color-grade1":Demension?.rarity_common?.rarity_post_color, "--color-grade2":Demension?.rarity_common?.rarity_post_color}} >1</span>

                                              <h5> 

                                                    {Demension?.rarity_common?.rare_type_title}

                                              </h5>

                                            </div>
                                            <h3 style={{"--color-border":Demension?.rarity_common?.rarity_post_color}} >{RareDate?.percentage}%</h3>

                                            <p style={{"--text-color":Demension?.rarity_common?.rarity_post_color}} >

                                                  {Demension?.rarity_common?.post_rarity_percentage?.replace(
                                                    "{percentage}",
                                                    (RareDate?.percentage || 0)
                                                  )}
                                            </p>

                                            {/* <h6>
                                              {" "}
                                              {Demension?.rarity_section?.post_rarity_description}
                                            </h6> */}

                                          </div>

                                          <div className="result-newDash2-b2">
                                            <div className="result-newDash2-chart">
                                              <div class="circular-chart-newDash2">
                                                <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_post_color}4D`} gauge_color={Demension?.rarity_common?.rarity_post_color}  value={100 - RareDate?.percentage} gauge_title={Demension?.rarity_common?.graph_post_rarity_title} />
                                              </div>
                                              <div className="circular-chart-newDash2-bar" >
                                                <GradientSlider  gauge_color1={Demension?.rarity_common?.rarity_post_color} gauge_color2={Demension?.rarity_common?.rarity_archetype_color} value={RareDate?.percentage}  />
                                              </div>

                                              {/* <p >
                                                    {Demension?.rarity_common?.post_percentage?.replace(
                                                      "{percentage}",
                                                      100 - (RareDate?.percentage || 0)
                                                    )}
                                                </p> */}

                                            </div>
                                            <div className="result-newDash2-content">
                                              <div className="result-newDash2-sub">
                                                <div>
                                                  <span>

                                                    <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />

                                                  </span>
                                                  <h5> {Demension?.rarity_section?.post_rarity_label}</h5>
                                                </div>
                                                <p>
                                                    {Demension?.rarity_section?.post_rarity_description}
                                                </p>
                                              </div>
                                            </div>
                                          </div>

                                          {/* <div className="result-newDash2-b1 result-newDash2-b3"></div> */}
                                      </div>

                                      <div className="result-newDash2-box" style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >

                                          <div className="result-newDash2-b1">
                                            <div>
                                              <span style={{"--color-grade1":Demension?.rarity_common?.rarity_archetype_color, "--color-grade2":Demension?.rarity_common?.rarity_archetype_color}} >2</span>

                                              <h5> 

                                                    {Demension?.rarity_common?.rarity_title}

                                              </h5>

                                            </div>
                                            
                                                <h3  style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >{testData?.rarity_percentage}%</h3>

                                                <p  style={{"--text-color":Demension?.rarity_common?.rarity_archetype_color}} >

                                                      {Demension?.rarity_common?.archetype_rarity_percentage?.replace(
                                                        "{percentage}",
                                                        (testData?.rarity_percentage || 0)
                                                      )} 
                                                </p>

                                              {/* <h6 >
                                                {" "}

                                                  {Demension?.rarity_section?.archetype_rarity_description}

                                              </h6> */}

                                          </div>

                                          <div className="result-newDash2-b2">

                                              <div className="result-newDash2-chart">
                                                
                                                <div class="circular-chart-newDash2">
                                                  <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_archetype_color}4D`}  gauge_color={Demension?.rarity_common?.rarity_archetype_color}  value={100 -testData?.rarity_percentage} gauge_title={Demension?.rarity_common?.graph_archetype_rarity_title} />
                                                </div>
                                                <div className="circular-chart-newDash2-bar">
                                                  <GradientSlider gauge_color1={Demension?.rarity_common?.rarity_archetype_color} gauge_color2={Demension?.rarity_common?.rarity_post_color}  value={testData?.rarity_percentage}  />

                                                  
                                                </div>

                                                  {/* <p >
                                                      {Demension?.rarity_common?.archetype_rarity_percentage?.replace(
                                                        "{percentage}",
                                                        100 - (testData?.rarity_percentage || 0)
                                                      )} 
                                                  </p> */}

                                              </div>
                                              <div className="result-newDash2-content">
                                                <div className="result-newDash2-sub">
                                                  <div>
                                                    <span>
                                                      <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" />
                                                    </span>

                                                    <h5> {Demension?.rarity_section?.archetype_rarity_label}</h5>

                                                  </div>
                                                  <p>

                                                    {Demension?.rarity_section?.archetype_rarity_description}

                                                  </p>
                                                </div>
                                              </div>
                                          </div>

                                          {/* <div className="result-newDash2-b1 result-newDash2-b3"></div> */}
                                      </div>

                                      <div className="result-newDash2-weight">
                                        <div className="result-newDash2-weight-left">
                                          <span><img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" /></span>

                                          <h6>  {Demension?.rarity_common?.key_diffence_type}</h6>

                                        </div>

                                        <div className="result-newDash2-weight-right">

                                            <ul>
                                              <li style={{"--color-two":Demension?.rarity_common?.rarity_post_color}}>{Demension?.rarity_common?.key_term_1}  </li>
                                              <li style={{"--color-two":Demension?.rarity_common?.rarity_archetype_color}}>{Demension?.rarity_common?.key_term_2}</li>
                                            </ul>

                                        </div>
                                      </div>
                                  </div>

                                    <ResultChart
                                      resultRef={TestDone}
                                      onLoginChange={onLoginChange}
                                      past_test={HavePastTest}
                                      subplan={subplan}
                                      token={token}
                                      result={result_letter}
                                      testdata={testData}
                                      demension={Demension}
                                      opacity={Opacity}
                                      tierData={tierData}
                                    />

                                </>
            
                            );
                          }
    

                  }
                });

                if (buffer.length > 0) {
                  groupedElements.push(
                    <div className="extend-common" key="group-end">
                      {buffer}
                    </div>
                  );
                }

                return groupedElements;
              })()}
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-9 col-lg-9 final-subs-result">

            {/* <ResultChart
              resultRef={TestDone}
              onLoginChange={onLoginChange}
              past_test={HavePastTest}
              subplan={subplan}
              token={token}
              result={result_letter}
              testdata={testData}
              demension={Demension}
              opacity={Opacity}
              tierData={tierData}
            /> */}

             {/* {Demension?.rarity_common && (

                <div className="result-newDash2">

                    <div className="result-newDash2-title">
                      <span>

                        <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />
                        
                      </span>
                      <div>
                        <h5> {Demension?.rarity_common?.rarity_section_title}</h5>
                        <p>
                            {Demension?.rarity_common?.rarity_section_description}
                        </p>
                      </div>
                    </div>

                    <div className="result-newDash2-box" style={{"--color-border": Demension?.rarity_common?.rarity_post_color}} >

                        <div className="result-newDash2-b1">
                          <div>
                            <span style={{"--color-grade1":Demension?.rarity_common?.rarity_post_color, "--color-grade2":Demension?.rarity_common?.rarity_post_color}} >1</span>

                            <h5> 

                                  {Demension?.rarity_common?.rare_type_title}

                            </h5>

                          </div>
                          <h3 style={{"--color-border":Demension?.rarity_common?.rarity_post_color}} >{RareDate?.percentage}%</h3>

                          <p style={{"--text-color":Demension?.rarity_common?.rarity_post_color}} >

                                {Demension?.rarity_common?.post_rarity_percentage?.replace(
                                  "{percentage}",
                                  (RareDate?.percentage || 0)
                                )}
                          </p>

                        </div>

                        <div className="result-newDash2-b2">
                          <div className="result-newDash2-chart">
                            <div class="circular-chart-newDash2">
                              <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_post_color}4D`} gauge_color={Demension?.rarity_common?.rarity_post_color}  value={100 - RareDate?.percentage} gauge_title={Demension?.rarity_common?.graph_post_rarity_title} />
                            </div>
                            <div className="circular-chart-newDash2-bar" >
                              <GradientSlider  gauge_color1={Demension?.rarity_common?.rarity_post_color} gauge_color2={Demension?.rarity_common?.rarity_archetype_color} value={RareDate?.percentage}  />
                            </div>

                          </div>
                          <div className="result-newDash2-content">
                            <div className="result-newDash2-sub">
                              <div>
                                <span>

                                  <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image1}`} alt="" />

                                </span>
                                <h5> {Demension?.rarity_section?.post_rarity_label}</h5>
                              </div>
                              <p>
                                   {Demension?.rarity_section?.post_rarity_description}
                              </p>
                            </div>
                          </div>
                        </div>

                    </div>

                    <div className="result-newDash2-box" style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >

                        <div className="result-newDash2-b1">
                          <div>
                            <span style={{"--color-grade1":Demension?.rarity_common?.rarity_archetype_color, "--color-grade2":Demension?.rarity_common?.rarity_archetype_color}} >2</span>

                            <h5> 

                                  {Demension?.rarity_common?.rarity_title}

                            </h5>

                          </div>
                          
                              <h3  style={{"--color-border":Demension?.rarity_common?.rarity_archetype_color}} >{testData?.rarity_percentage}%</h3>

                              <p  style={{"--text-color":Demension?.rarity_common?.rarity_archetype_color}} >

                                    {Demension?.rarity_common?.archetype_rarity_percentage?.replace(
                                      "{percentage}",
                                      (testData?.rarity_percentage || 0)
                                    )} 
                              </p>

                      
                        </div>

                        <div className="result-newDash2-b2">

                            <div className="result-newDash2-chart">
                              
                              <div class="circular-chart-newDash2">
                                <DoughnutLinearChart bg_color_2={`${Demension?.rarity_common?.rarity_archetype_color}4D`}  gauge_color={Demension?.rarity_common?.rarity_archetype_color}  value={100 -testData?.rarity_percentage} gauge_title={Demension?.rarity_common?.graph_archetype_rarity_title} />
                              </div>
                              <div className="circular-chart-newDash2-bar">
                                <GradientSlider gauge_color1={Demension?.rarity_common?.rarity_archetype_color} gauge_color2={Demension?.rarity_common?.rarity_post_color}  value={testData?.rarity_percentage}  />

                                
                              </div>
                            </div>
                            <div className="result-newDash2-content">
                              <div className="result-newDash2-sub">
                                <div>
                                  <span>
                                    <img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" />
                                  </span>

                                  <h5> {Demension?.rarity_section?.archetype_rarity_label}</h5>

                                </div>
                                <p>

                                  {Demension?.rarity_section?.archetype_rarity_description}

                                </p>
                              </div>
                            </div>
                        </div>

                    </div>

                    <div className="result-newDash2-weight">
                      <div className="result-newDash2-weight-left">
                        <span><img src={`${IMG_URL}/d0/${Demension?.rarity_common?.rarity_image2}`} alt="" /></span>

                        <h6>  {Demension?.rarity_common?.key_diffence_type}</h6>

                      </div>

                      <div className="result-newDash2-weight-right">

                          <ul>
                            <li style={{"--color-two":Demension?.rarity_common?.rarity_post_color}}>{Demension?.rarity_common?.key_term_1}  </li>
                            <li style={{"--color-two":Demension?.rarity_common?.rarity_archetype_color}}>{Demension?.rarity_common?.key_term_2}</li>
                          </ul>

                      </div>
                    </div>
                </div>
            )} */}

            {/* {RareDate && (

              <div className="result-newDash">
                <div className="result-newDash-outer">
                  <div className="result-newDash-title">
                    <span>{Demension?.rare_type_title}</span>

                    <h5>{RareDate?.heading?.replace('{percentage}', RareDate?.percentage)}</h5>
                    <p>
                      {RareDate?.description}
                    </p>
                  </div>

                  <div className="result-newDash-value-box">
                    <div className="result-newDash-value-box-inner">
                      <div className="per-value">
                        <p>Rarity Score</p>
                        <h2>{RareDate?.percentage}%</h2>
                      </div>
                      <button>{RareDate?.name}</button>
                    </div>

                    <div className="result-newDash-bar">
                      <div class="two-card-progress">
                        <div class="progress-bar-fill-repeat-title">
                          <span><span>{RareDate?.extreme_type}</span></span>
                          <div>Top {100 - RareDate?.percentage}%</div>
                        </div>
                        <div class="two-card-progress2">
                          <div class="progress-bar-fill-repeat"
                           style={{
                              background: `linear-gradient(
                                90deg,
                                #8c30a8b5 ${100 - RareDate?.percentage}%,
                                #cda632 40%
                              )`,
                            }}
                          >

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="result-newDash-textDiv">

                    <div dangerouslySetInnerHTML={{__html:RareDate?.matters}} />
                    
                    <div dangerouslySetInnerHTML={{__html:RareDate?.fallback}} />

                    <div dangerouslySetInnerHTML={{__html:RareDate?.dev_note}} />

                  </div>

                  <div className="result-newDash-textDiv rariry-result">

                        {Demension?.rarity_name && (
                          <div className="rarity-des result-newDash-title">

                              <span>{Demension?.rarity_title}</span>
                                <h5>{Demension?.rarity_name?.replace('{rarity}', testData?.rarity_percentage)}</h5>
                                <p>{Demension?.rarity_description}</p>
                          </div>
                        )}
                  </div>


                </div>
              </div>
              
            )} */}

              {/* <Trail 
              
                resultRef={TestDone}
                onLoginChange={onLoginChange}
                past_test={HavePastTest}
                subplan={subplan}
                token={token}
                result={result_letter}
                testdata={testData}
                demension={Demension}
                opacity={Opacity}
              
              /> */}

            {/* <Subscriptions subs={subS} Subcription={Subcription} onLoginChange={onLoginChange} /> */}

            <ResultTwo test_id={testData?.test?.id} />
                        
                        
                          

            <div className="free-unpaid-res">
              <ResultPageLast

                userdetail={userdetail}
                TestLink={TestLink1}

                type="result"
                onLoginChange={onLoginChange}
                token={token}
                payment={hasplan}
                slug={slug}
                demension={Demension}
              />
            </div>
          </div>
          

          {ShowModal && (
                                            
              <div 
                  className={`newdashpop-overlay subs-cognit-modal1 modal_subcript ${
                   subscription?.data?.length == 1 ? "single-subscription" : ""
                  }`}
                
                >

                    <div className="newdashpop-inner">

                        <div className="newdashpop-container">

                            <button
                                className="newdashpop-close"
                                onClick={() => setShowModal(false)}
                                >
                                &times;
                            </button>

                            <div className="conent-pop">
                            
                            <Subscriptions subs={subAd} userdetail={userdetail} Subcription={subscription} onLoginChange={onLoginChange}/>

                            </div>

                        </div>

                    </div>

                </div>
            )}

        </div>
      </div>
    </div>

    </>
  );
}

export default FinalPage;
